import { css, SerializedStyles } from '@emotion/react';
import { BaseEmoji } from 'emoji-mart';

export interface BaseInterface {
	className: string;
	withAttachments?: boolean;
	emojiPanelActive: boolean;
	onAttachmentClick: VoidFunction;
	setShowEmoji?: (v: boolean) => void;
	onEmojiPick?: (v: BaseEmoji) => void;
}

export const styles = (): SerializedStyles => css`
	align-items: flex-end;
	display: flex;
	position: relative;

	.btn-group {
		display: flex;

		&_column {
			align-items: center;
			flex-direction: column;
			justify-content: space-between;
			align-self: normal;
		}

		&_row {
			align-self: flex-end;
			align-items: center;
			height: 30px;
			justify-content: flex-end;
			position: relative;

			& > * {
				align-items: center;
				display: flex;
			}
		}
		.btn-wrapper {
			& > .ncc-emoji {
				margin-right: 8px;
			}
		}
	}
`;
